import React from "react";

import { DoorGlassMaterial } from "../../../../../shared/utils/door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import { Euler } from "three";
import {
  defaultDoorWidth,
  defaultJHandleYPosition,
  defaultJHandleZPosition,
  defaultSideFrameWidth,
  defaultUHandleConnectorXPosition,
} from "shared/utils/doorSceneConstants";
import { lerp } from "three/src/math/MathUtils";
import { getGeometryBounds2D, getOpeningAnchoredX } from "./openingGeometry";

interface HandleProps {
  doorNodes: any;
  materials: DoorGlassMaterial;
  reverse?: boolean;
  index: number;
  shiftZValue?: number;
  shiftXValue?: number;
  secondaryDoorDoubleJHandle?: boolean;
}

const JHandle: React.FC<HandleProps> = ({
  doorNodes,
  materials,
  reverse = false,
  index,
  shiftZValue,
  shiftXValue,
  secondaryDoorDoubleJHandle,
}: HandleProps) => {
  const { getConfigurationWidth, getConfigurationColor } =
    useConfigurationOptionsContext();

  // Rotation
  const rotation = new Euler(Math.PI, (3 * Math.PI) / 2, 0);

  const width = getConfigurationWidth(index);
  const glassBounds = getGeometryBounds2D(doorNodes.glass.geometry);
  const clampedWidth = Math.max(600, Math.min(1150, width));
  const interpolatedFactor = lerp(
    0.066,
    0.045,
    (clampedWidth - 600) / (1150 - 600),
  );
  const defaultConnectorX = reverse
    ? (defaultDoorWidth / 2 -
        (defaultSideFrameWidth + defaultUHandleConnectorXPosition)) /
      1000
    : -(
        defaultDoorWidth / 2 -
        (defaultSideFrameWidth + defaultUHandleConnectorXPosition)
      ) / 1000;
  const baseHandleX = getOpeningAnchoredX({
    glassBounds,
    width,
    defaultX: defaultConnectorX,
    reverse,
  });
  const handlePositionX = reverse
    ? baseHandleX + interpolatedFactor
    : baseHandleX - interpolatedFactor;
  const handlePositionY = defaultJHandleYPosition / 1000;
  const handlePositionZ = defaultJHandleZPosition + (shiftZValue ?? 0);

  return (
    <group>
      {!secondaryDoorDoubleJHandle && (
        <mesh
          geometry={doorNodes["handle_jgreep_front"].geometry}
          material={materials[getConfigurationColor()]}
          position={[
            handlePositionX + (shiftXValue ?? 0),
            handlePositionY,
            handlePositionZ,
          ]}
          rotation={rotation}
          // position-z={0}
        />
      )}

      {/* Jgreep back */}
      <mesh
        geometry={doorNodes["handle_jgreep_back"].geometry}
        material={materials[getConfigurationColor()]}
        position={[
          secondaryDoorDoubleJHandle
            ? -handlePositionX + (shiftXValue ?? 0) - 0.005
            : handlePositionX + (shiftXValue ?? 0) + 0.005,

          handlePositionY,

          handlePositionZ + (shiftZValue ? -0.03 : 0),
        ]}
        rotation={rotation}
        // position-z={0}
      />
    </group>
  );
};

export default JHandle;
